module.exports = __webpack_public_path__ + "static/logo-update-e9ce6d35777125c4720a18ba55389f55.png";